export const faqData = {
  badge: "FAQ",
  headline: "Frequently Asked Questions",
  description:
    "Can't find what you're looking for? Reach out to one of our specialists and we will answer any questions you may have.",
  ctaButton: {
    text: "Get In Touch",
    link: "/contact",
  },
  questions: [
    {
      question:
        "How do you ensure our ads comply with ASA (Advertising Standards Authority) and HPRA guidelines?",
      answer:
        "We focus on the benefits and results of the treatment (skin rejuvenation or redefining features) rather than mentioning prescription-only brand names, ensuring full alignment with ASA and HPRA standards.",
    },
    {
      question: "What is your process for qualifying leads?",
      answer:
        "Our medically trained team qualifies every lead to ensure they are clinically suitable, filtering out time-wasters and saving your clinic's resources.",
    },
    {
      question: "Which booking software do you integrate with?",
      answer:
        "We provide API-level integration with your existing software (Phorest, Timely, or Pabau) to ensure real-time calendar availability and prevent double bookings. We implement a Stripe-integrated gateway that requires a non-refundable booking fee £50/€50 to secure the slot, which is then deducted from the final treatment cost.",
    },
    {
      question: "How do you handle no-show protection?",
      answer:
        "Our system sends automated reminders at 24 and 4 hours before the appointment. If they don't show, the deposit is automatically forfeited to cover your overhead.",
    },
    {
      question: "Can you run multiple service campaigns at the same time?",
      answer:
        "Yes, we can run multiple campaigns simultaneously for different services like HIFU, fillers, laser treatments, and more. Each campaign is strategically targeted to reach the right audience for that specific service.",
    },
    {
      question: "How does your performance-based pricing work?",
      answer:
        "Simple — if you don't get paid, we don't get paid. We operate on a pure performance model, meaning our fee is tied directly to the confirmed bookings and deposits we generate for your clinic. No results, no invoice. This removes all the risk from your side and keeps us fully accountable.",
    },
    {
      question: "How long until we see results?",
      answer:
        "Most clinics see their first confirmed bookings within the first 2 weeks of campaigns going live. Full pipeline momentum typically builds over 30–60 days as we optimise targeting, refine messaging, and scale what's working.",
    },
    {
      question: "Do you require a long-term contract?",
      answer:
        "No long-term contracts. We work on a rolling monthly basis because we believe results should speak for themselves. If you're not seeing value, you're free to walk away — though in our experience, clinics that follow the process don't want to.",
    },
  ],
};
